














import { defineComponent, useRouter } from '@nuxtjs/composition-api'

// Store
import { useSearchStore } from '@/store/search'

// Composables
import useFacets from '@/composables/search/useFacets'
import useSearchUrl from '@/composables/search/useSearchUrl'

// Components
import IconFa6SolidXmark from '~icons/fa6-solid/xmark'

// Commmon
import { decodeHTMLEntities } from '@/common/utils/characters'
import { nestedFacets, FACETNAMES } from '@/common/static/facets'

export default defineComponent({
  components: {
    IconFa6SolidXmark,
  },

  props: {
    facet: {
      required: true,
      type: Object,
    },
  },

  setup() {
    const { getSelectedFacetCount, deleteFacetValue, mapToFacetName } = useFacets()
    const router = useRouter()
    const { getSearchUrl } = useSearchUrl()
    const searchStore = useSearchStore()
    // const showKey = ref(false)

    // Delete one applied facet
    const clearAppliedFacet = (facet: string, value: string) => {
      // change facets
      deleteFacetValue(facet, value)
      searchStore.clearMultiselectFacetState()

      // perform search
      router.push(getSearchUrl())
    }

    const getSelectedFacetText = (key: string, value: string) => {
      // If is other
      if (nestedFacets.includes(key)) {
        return mapToFacetName(key, FACETNAMES.PRETTY_FACET_NAME) + ' (' + getSelectedFacetCount(key, value) + ')'
      }

      return value + ' (' + getSelectedFacetCount(key, value) + ')'
    }

    return {
      clearAppliedFacet,
      decodeHTMLEntities,
      mapToFacetName,
      nestedFacets,
      getSelectedFacetText,
      FACETNAMES,
    }
  },
})
